module.exports = supabase;